var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"handler",style:(_vm.marginStyle),attrs:{"type":_vm.icon,"size":16},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }